import { tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.modalBg};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px;

  @media (${tabletMax}) {
    padding: 5px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 5px;
  right: 5px;
`;

export const Header = styled.div<{ $border: boolean }>`
  position: relative;
  border-bottom: ${({ theme, $border }) => ($border ? `1px solid ${theme.keyline}` : 'none')};
  padding: ${({ $border }) => ($border ? `15px 50px 15px 30px` : '0')};

  @media (${tabletMax}) {
    padding: ${({ $border }) => ($border ? `15px 50px 15px 15px` : '0')};
  }
`;

export const Content = styled.div<{ maxWidth?: number }>`
  max-width: ${(props) => props.maxWidth || 1024}px;
  width: 100%;
  background-color: ${({ theme }) => theme.modalContentBg};
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  max-height: 100%;
  display: flex;
  flex-direction: column;
`;

export const Body = styled.div<{ $collapseContent?: boolean }>`
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  flex: 1;

  ${({ $collapseContent }) =>
    !$collapseContent &&
    css`
      padding: 30px;

      @media (${tabletMax}) {
        padding: 30px 15px 30px;
      }
    `}
`;
